import { render, staticRenderFns } from "./Leis.vue?vue&type=template&id=1728b516&scoped=true"
import script from "./Leis.vue?vue&type=script&lang=js"
export * from "./Leis.vue?vue&type=script&lang=js"
import style0 from "./Leis.vue?vue&type=style&index=0&id=1728b516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1728b516",
  null
  
)

export default component.exports